
import './../css/mk-brand.css';

import {useEffect} from "react";
import discordLogo from "../media/discord-logo2.png";
import twitterLogo from "../media/twitter-logo.png";
import instagramLogo from "../media/instagram-logo3.png";

function FooterPanel() {
  useEffect(() => {}, );
  return (
      <div className="bg-black">
          <div id="footer-panel">
              <div className="max-w-5xl mx-auto px-4">
                  <div className="flex justify-between">
                      <div className="flex items-center text-brand-text">
                          <div className="text-small">© Copyright 2022 metaKitchen.io</div>
                      </div>
                      <div className="flex items-center text-brand-text">
                          <div onClick={()=>{window.open("https://discord.gg/metakitchen")}}>
                              <img
                                  className="social-logo m-2 cursor-pointer"
                                  alt="metaKitchen Discord connection link"
                                  src={discordLogo}
                              />
                          </div>
                          <div>
                              <a href="https://twitter.com/meta_Kitchen">
                                  <img
                                      className="social-logo m-2"
                                      alt="metaKitchen Twitter feed"
                                      src={twitterLogo}
                                  />
                              </a>
                          </div>
                          <div>
                              <a href="https://instagram.com/metakitchennft">
                                  <img
                                      className="social-logo m-2"
                                      alt="metaKitchen Instagram page"
                                      src={instagramLogo}
                                  />
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  );
}

export default FooterPanel;

